export const SEARCH_USERS = "SEARCH_USERS";
export const APPEND_SEARCH_USERS = "APPEND_SEARCH_USERS";
export const SET_SEARCH_META = "SET_SEARCH_META";
export const GET_USER = "GET_USER";
export const CLEAR_USERS = "CLEAR_USERS";
export const CLEAR_USER_SEARCH_RESULTS = "CLEAR_USER_SEARCH_RESULTS";
export const GET_REPOS = "GET_REPOS";
export const SET_LOADING = "SET_LOADING";
export const SET_SEARCH_LOADING = "SET_SEARCH_LOADING";
export const SET_FEATURED_LOADING = "SET_FEATURED_LOADING";
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const SET_RATE_LIMIT = "SET_RATE_LIMIT";
export const SET_API_ERROR = "SET_API_ERROR";
export const CLEAR_API_ERROR = "CLEAR_API_ERROR";
export const CACHE_PROFILE = "CACHE_PROFILE";
export const SET_FEATURED_USERS = "SET_FEATURED_USERS";
export const SET_REPOS_FOR_LOGIN = "SET_REPOS_FOR_LOGIN";
export const APPEND_REPOS_FOR_LOGIN = "APPEND_REPOS_FOR_LOGIN";
export const SET_CARD_REPOS_LOADING = "SET_CARD_REPOS_LOADING";
export const SET_LANGUAGE_STATS = "SET_LANGUAGE_STATS";
export const SET_INSIGHT_LOGIN = "SET_INSIGHT_LOGIN";
export const SET_INSIGHT_BUNDLE = "SET_INSIGHT_BUNDLE";
export const SEARCH_REPOS = "SEARCH_REPOS";
export const CLEAR_REPO_SEARCH_RESULTS = "CLEAR_REPO_SEARCH_RESULTS";
export const SET_REPO_SEARCH_META = "SET_REPO_SEARCH_META";
export const SET_REPO_SEARCH_LOADING = "SET_REPO_SEARCH_LOADING";
